import type { Object3D, Vector3 } from '@anov/3d-core'

/**
 * 拆楼模式
 */
export enum EBuildingSplitType {
  Hide = 'hide', // 隐藏上方楼层
  Move = 'move', // 定向移动
  Solo = 'solo', // 单层显示
}

/**
 * 移动方向枚举
 */
export enum EDirection {
  Left = 'left',
  Right = 'right',
  Front = 'front',
  Back = 'back',
  Left_Front = 'left_front',
  Right_Front = 'right_front',
  Left_Back = 'left_back',
  Right_Back = 'right_back',
}

export type AnimationOption = {
  type: EBuildingSplitType
  duration: number // 动画时长
  rule?: {
    direction?: number[] // 移动方向
  }
}

export type Option = {
  building: Object3D // 建筑模型
  floor?: number // 拆分的楼层号
  animation?: AnimationOption // 动画
}
